import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from '../helper/constants';
import { HttpService } from '../helper/httpService';
import { QuestionAndAnswerModel } from '../viewmodels/questionAndAnswer.model';
import { ChangeDecisionModel } from '../viewmodels/change-decision.model';
import { BespokeLetterModel } from '../viewmodels/bespoke-letter.model';
import { InterfaceDocument } from '../../../authentication/viewmodels/interface-document';
import { LetterResultResponseViewModel } from '../viewmodels/letter-result-viewmodel';

@Injectable()
export class LetterService {
  private letterServiceUrl = Constants.serverUrl + 'api/letter/';

  constructor(public http: HttpService) {}

  /** createLetterAsHtml */
  createLetterAsHtml(
    repId: number,
    questionAndAnswers: QuestionAndAnswerModel[]
  ): Observable<LetterResultResponseViewModel> {
    const data = JSON.stringify(questionAndAnswers);

    return this.http
      .Post(this.letterServiceUrl + 'createLetterAsHtml' + '/' + repId, data)
      .pipe(map((res: any) => res as LetterResultResponseViewModel));
  }

  // createLetterAsHtml(
  //   repId: number,
  //   questionAndAnswers: any[]
  // ): Observable<LetterResultResponseViewModel> {
  //   return this.http.Post<LetterResultResponseViewModel>(
  //     `${this.letterServiceUrl}createLetterAsHtml/${repId}`,
  //     JSON.stringify(questionAndAnswers)
  //   );
  // }

  /** changeDecision */
  changeDecision(decisionObj: ChangeDecisionModel): Observable<any> {
    const data = JSON.stringify(decisionObj);

    return this.http.Post(this.letterServiceUrl + 'changeDecision', data);
  }

  /** createBespokeLetter */
  createBespokeLetter(bespokeLetterObj: BespokeLetterModel): Observable<any> {
    const data = JSON.stringify(bespokeLetterObj);

    return this.http.Post(this.letterServiceUrl + 'createBespokeLetter', data);
  }

  /** isTitleNeeded */
  isTitleNeeded(): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'isTitleNeeded');
  }

  /** reasonIsPCNReceiptDenied */
  reasonIsPCNReceiptDenied(): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'reasonIsPCNReceiptDenied');
  }

  /** getShowBespokeFields */
  getShowBespokeFields(): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'getShowBespokeFields');
  }

  /** savePreviewLetter */
  savePreviewLetter(): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'savePreviewLetter');
  }

  /** saveEditedLetter */
  saveEditedLetter(interfaceDocument: InterfaceDocument): Observable<any> {
    const data = JSON.stringify(interfaceDocument);
    return this.http.Post(this.letterServiceUrl + 'saveEditedLetter', data);
  }

  /** convertHtmlToLetter **/
  convertHtmlToLetter(html: string): Observable<any> {
    const data = JSON.stringify(html);
    return this.http.PostBlob(this.letterServiceUrl + 'convertHtmlToLetter', data).pipe(
      map((res) => {
        const blob = new Blob([res], { type: 'docx' });
        return blob;
      })
    );
  }

  /** convertHtmlToRtf **/
  convertHtmlToRtf(html: string): Observable<Blob> {
    const data = JSON.stringify(html);
    return this.http
      .PostBlob(this.letterServiceUrl + 'convertHtmlToRtf', data)
      .pipe(map((res) => new Blob([res], { type: 'application/rtf' })));
  }

  isRequestInfoAllowed(stageId: number): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'isRequestInfoAllowed');
  }

  /** getTodaysLettersForUser**/
  getTodaysLettersForUser(): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'getTodaysLettersForUser');
  }

  RetryAllTodaysLettersForUser(): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'RetryAllTodaysLettersForUser');
  }

  RetryLetter(letterId) {
    const data = JSON.stringify(letterId);

    return this.http.Post(this.letterServiceUrl + 'RetryLetter', data);
  }

  /** GetLetter */
  getLetter(letterId: number): Observable<any> {
    return this.http.Get(this.letterServiceUrl + 'getLetter' + '/' + letterId);
  }
}
